import { TValueOrFunc } from '@/config/types'

export const capitalize = (str: string) => {
  const lower = str.toLowerCase()
  return str.charAt(0).toUpperCase() + lower.slice(1)
}

export const resolveValue = <T>(value: TValueOrFunc<T>): T => {
  return value instanceof Function ? value() : value
}
